import { Pipe, PipeTransform } from '@angular/core';
import { CustomerAccountingInfo } from './model';

@Pipe({
  name: 'customerTabFilter'
})
export class CustomerTabFilterPipe implements PipeTransform {

  transform(items: CustomerAccountingInfo[], onlyNotSent: boolean): CustomerAccountingInfo[] {
    console.log(onlyNotSent);
    if (onlyNotSent) {
      return items.filter(item => item.notifications?.length == 0 || item.notifications?.find(n => n.dateSent != null) == null);
    }

    return items;
  }

}
